import { CallAPI } from '../../utils/util';
import React, { Component } from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import { PatientNav } from './patientnav';

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
      let location = useLocation();
      let navigate = useNavigate();
      let params = useParams();

      return (
          <Component
              {...props}
              router={{ location, navigate, params }}
          />
      );
  }
  return ComponentWithRouterProp;
}

class DoctorComments extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rows: [],
            doctor: undefined,
            patientID: this.props.router.params.patientId
        };
    }

    componentDidMount() {
        CallAPI({}, `patients/${this.state.patientID}/doctorsComments/1`, 'GET', (res) => {
            this.setState({"rows": res});
            if (res.length > 0){
                this.setState({ "doctor": res[0].First_Name + " " + res[0].Last_Name });
            } else {
                this.setState({"doctor" : "No comments on file"});
            }
        });
    }

    getRows = () => {
        let i = 0;
        return this.state.rows.map(function(row){
            return (
                <div className='centerSpacer' key={i++}>
                    <div className='subHeading marginBottom2 leftAlign red'>{row.Question}</div><br/>
                    <div className='centerAlign'>
                        <div className='leftAlign'>Observation: {row.Radio}</div><br/>
                        <div className='leftAlign'>Comments: {row.Comment}</div><br/>
                        <div className='leftAlign'>Timestamp: {row.Timestamp}</div><br/><br/>
                    </div>
                </div>
            );
        });
    }

    render = () => {
        return (
            <div>
            <PatientNav patientId={this.state.patientID} />
            <div className="stackSpacer"></div>
            <h4 className="signIn centerSpacer">Doctor Observations</h4>
            <h5 className="centerSpacer">{this.state.doctor}</h5><br/>
            
            {this.getRows()}
            </div>
            );
        };
}

export default withRouter(DoctorComments)